export const NETWORK_SCOPE_OPTIONS = [
  { value: 'in-network', label: 'In Network' },
  { value: 'out-of-network', label: 'Out Of Network' },
];

export const OON_PARAMS_GROUP_PROGRAMS = {
  'q[include_address_book]': true,
};
